export default {
  'en.auth': require('../../../lang/en/auth.php'),
  'en.culture': require('../../../lang/en/culture.php'),
  'en.attribute': require('../../../lang/en/attribute.php'),
  'en.user': require('../../../lang/en/user.php'),
  'en.validation': require('../../../lang/en/validation.php'),
  'en.default': require('../../../lang/en/default.php'),
  'en.life_cycle': require('../../../lang/en/life_cycle.php'),
  'en.contacts': require('../../../lang/en/contacts.php'),
  'en.file': require('../../../lang/en/file.php'),
  'en.invoice': require('../../../lang/en/invoice.php'),
  'en.history': require('../../../lang/en/history.php'),
  'en.offline': require('../../../lang/en/offline.php'),

  'de.accounts': require('../../../lang/de/accounts.php'),
  'de.auth': require('../../../lang/de/auth.php'),
  'de.boards': require('../../../lang/de/boards.php'),
  'de.culture': require('../../../lang/de/culture.php'),
  'de.attribute': require('../../../lang/de/attribute.php'),
  'de.user': require('../../../lang/de/user.php'),
  'de.validation': require('../../../lang/de/validation.php'),
  'de.default': require('../../../lang/de/default.php'),
  'de.life_cycle': require('../../../lang/de/life_cycle.php'),
  'de.contacts': require('../../../lang/de/contacts.php'),
  'de.contracts': require('../../../lang/de/contracts.php'),
  'de.appointments': require('../../../lang/de/appointments.php'),
  'de.courses': require('../../../lang/de/courses.php'),
  'de.protocols': require('../../../lang/de/protocols.php'),
  'de.persons': require('../../../lang/de/persons.php'),
  'de.participations': require('../../../lang/de/participations.php'),
  'de.qualifications': require('../../../lang/de/qualifications.php'),
  'de.schedules': require('../../../lang/de/schedules.php'),
  'de.file': require('../../../lang/de/file.php'),
  'de.invoice': require('../../../lang/de/invoice.php'),
  'de.history': require('../../../lang/de/history.php'),
  'de.structures': require('../../../lang/de/structures.php'),
  'de.dashboard':require('../../../lang/de/dashboard.php'),
  'de.offline': require('../../../lang/de/offline.php'),
  'de.archive': require('../../../lang/de/archive.php'),
}



// WEBPACK FOOTER //
// ./resources/assets/js/i18n/messages.js